<div class="form-container">
  <alert></alert>
  <h2>Customer: {{ customer?.name || customerId }}</h2>
  <div class="col-md-8 pl0">
    @for (detail of details; track detail[0]) {
      <div class="row">
        <div class="col-md-3">{{ detail[0] }}</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">{{ detail[1] }}</div>
      </div>
    }
    @if (customer?.status) {
      <div class="row">
        <div class="col-md-3">Status</div>
        <div class="col-md-1">:</div>
        <div class="col-md-7">
          <span class="badge {{ customer.status === 'active' ? 'badge-success' : 'badge-secondary' }}">{{ customer.status }}</span>
        </div>
      </div>
    }
  </div>

  <h3 class="h5 mt-4">Users ({{ userCount | number }})</h3>
  @if (loading) {
    <p>Loading...</p>
  } @else {
    <table class="table table-bordered table-sm">
      <thead>
        <tr><th class="sort-na">Email</th><th class="sort-na">Role</th><th class="text-center sort-na">Status</th><th class="sort-na">Assigned projects</th></tr>
      </thead>
      <tbody>
        @for (user of users; track user.id) {
          <tr>
            <td><a [routerLink]="['/dashboard/user/view', user.id]" [state]="{ data: { user: user } }">{{ user.email }}</a></td>
            <td>{{ user.role }}</td>
            <td class="text-center">
              <span class="badge {{ user.status === 'active' ? 'badge-success' : 'badge-secondary' }}">{{ user.status }}</span>
            </td>
            <td>
              @for (project of user.projects; track project; let last = $last) {
                {{ project.name }}@if (!last) {, }
              }
            </td>
          </tr>
        } @empty {
          <tr><td colspan="4" class="text-center">No users</td></tr>
        }
      </tbody>
    </table>
  }

  <h3 class="h5 mt-4">Projects ({{ projectCount | number }})</h3>
  @if (loading) {
    <p>Loading...</p>
  } @else {
    <table class="table table-bordered table-sm">
      <thead>
        <tr><th class="sort-na">Name</th><th class="text-center sort-na">Status</th><th class="text-right sort-na">Files</th><th class="sort-na">Created</th></tr>
      </thead>
      <tbody>
        @for (project of projects; track project.id) {
          <tr>
            <td><a [routerLink]="['/dashboard/project/', 'view', project.id]" [state]="{ data: { project: project } }">{{ project.name }}</a></td>
            <td class="text-center">
              <span class="badge {{ project.status === 'active' ? 'badge-success' : 'badge-secondary' }}">{{ project.status }}</span>
            </td>
            <td class="text-right">{{ project.totalFileCount | number }}</td>
            <td>{{ project.createdAt | date:'shortDate' }}</td>
          </tr>
        } @empty {
          <tr><td colspan="4" class="text-center">No projects</td></tr>
        }
      </tbody>
    </table>
  }

  <div class="row footer">
    <a [routerLink]="['/dashboard/customer/list']" class="btn btn-sm btn-primary">Back to Customer List</a>
    @if (customer?.email) {
      <a [routerLink]="['/dashboard/customer/edit/', customerId]" class="btn btn-sm btn-edit"
        [state]="{ data: { view: 'edit', customer: customer } }" title="Edit Customer"><i class="fa fa-fw fa-edit"></i> Edit</a>
    }
  </div>
</div>
